import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSuggestionsButtonAction } from '../../hooks/use-suggestions-button-action';
import { SuggestionListItemServicesPage } from './suggestion-list-item-services-page';
import { SuggestionListItemPromoPage } from './suggestion-list-item-promo-page';
import { SuggestionsList } from './suggestions-list';
import { PinnedSuggestion } from 'types/model';

type SuggestionsDefaultListProps = {
  suggestionSelector: string;
  index: number;
  isSrp: boolean;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  pinnedSuggestions: PinnedSuggestion[];
};

export const SuggestionsDefaultListPinnedItems = memo<SuggestionsDefaultListProps>(
  ({ suggestionSelector, index, isSrp, buttonAction, pinnedSuggestions }) => {
    const { t } = useTranslation();
    return (
      <>
        <SuggestionsList
          suggestionSelector={suggestionSelector}
          aria-label={t('header.searchbar.top-month')}
          data-qa={'pinned-promo-suggestions'}
        >
          {pinnedSuggestions.map((suggestion, pinnedIndex) => (
            <SuggestionListItemPromoPage
              key={`promo_${suggestion.title}`}
              elementIndex={pinnedIndex}
              navigationIndex={index}
              isSrp={isSrp}
              suggestionSelector={suggestionSelector}
              buttonAction={buttonAction}
              suggestion={suggestion}
            />
          ))}
        </SuggestionsList>
        <SuggestionsList
          suggestionSelector={suggestionSelector}
          aria-label={t('header.searchbar.projects-services')}
          data-qa={'pinned-services-suggestions'}
        >
          <SuggestionListItemServicesPage
            elementIndex={pinnedSuggestions.length}
            navigationIndex={index}
            isSrp={isSrp}
            suggestionSelector={suggestionSelector}
            buttonAction={buttonAction}
          />
        </SuggestionsList>
      </>
    );
  },
);
